import { z } from "zod";
import { MultiPolygonGeometry } from "./geo";

// Forest compartments (oddziały) from the Forest Data Bank (Bank Danych o Lasach, Lasy Państwowe,
// open data), issue #197. The server fetches them in XYZ tiles of zoom 13 (about 3 × 3 km in
// Poland, packages/geo tiles.ts) and keeps them; phones keep the tiles they got, for offline use.
// Searchers and the forest service name places by compartment number.

export const FOREST_TILE_ZOOM = 13;
/** Below this map zoom compartments are too small to read: nothing is fetched or drawn. */
export const FOREST_MIN_ZOOM = 12;
export const FOREST_ATTRIBUTION = "Bank Danych o Lasach © Lasy Państwowe";

export const ForestCompartment = z.object({
  type: z.literal("Feature"),
  geometry: MultiPolygonGeometry,
  properties: z.object({
    /** Stable across tiles: a compartment crossing a tile edge comes in both tiles. */
    id: z.string(),
    /** The compartment number as on forest maps, e.g. "285" or "102a". */
    number: z.string(),
    /** Leśnictwo; null outside the state forests. */
    range: z.string().nullable(),
    /** Nadleśnictwo; null outside the state forests. */
    district: z.string().nullable(),
  }),
});
export type ForestCompartment = z.infer<typeof ForestCompartment>;

export const ForestTile = z.object({
  type: z.literal("FeatureCollection"),
  features: z.array(ForestCompartment),
});
export type ForestTile = z.infer<typeof ForestTile>;

/** One collection: a compartment crossing a tile edge comes in both tiles, but is drawn once. */
export function mergeForestTiles(tiles: Iterable<ForestTile>): ForestTile {
  const byId = new Map<string, ForestCompartment>();
  for (const tile of tiles) for (const f of tile.features) byId.set(f.properties.id, f);
  return { type: "FeatureCollection", features: [...byId.values()] };
}
